import { get } from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

import { getMvtConfig } from './config';
import { getRootDomain, getUrlParamByKey } from './helpers/url';

export const TaggingEventNames = {
	rendered: 'aoChatbotRendered',
	interaction: 'aoChatbotInteraction',
	responseDetail: 'aoChatbotResponseDetail',
	responseMessageDetail: 'aoChatbotResponse', //TODO: Rename this so it relates to individual messages
	event: 'aoChatbotEvent', // TODO: Remove as doesn't appear to be used by Google Tag Manager
	recommendedProductsViewed: 'aoChatbotRecommendedProductViewed',
	recommendedProductsClicked: 'aoChatbotRecommendedProductClicked',
	connectingDuration: 'liveChatConnectingDuration',
	transferringDuration: 'liveChatTransferDuration',
	liveChatSessionDetails: 'liveChatSessionDetails',
	feedbackSubmitted: 'feedbackSubmitted',
	feedbackFormClose: 'aoChatbotFeedbackFormClose',
	productCardView: 'aoChatbotProductCardView',
	toastNotificationOnOpen: 'aoChatbotToastNotificationOnOpen',
	toastNotificationOnDismiss: 'aoChatbotToastNotificationOnDismiss',
	addToBasket: 'aoChatbotAddToBasket',
};

export enum IconTypes {
	Search,
	Products,
	Faulty,
	Order,
	Delivery,
	Finance,
	Question,
	LiveChat,
	Account,
	Damaged,
	Services,
	Deals,
}

export const IconClassMap = {
	[IconTypes.Search]: 'search',
	[IconTypes.Products]: 'laundry',
	[IconTypes.Faulty]: 'installation',
	[IconTypes.Order]: 'basket',
	[IconTypes.Delivery]: 'delivery',
	[IconTypes.Finance]: 'finance-gbp',
	[IconTypes.Question]: 'question-circle',
	[IconTypes.LiveChat]: 'live-chat',
	[IconTypes.Account]: 'account',
	[IconTypes.Damaged]: 'product-info',
	[IconTypes.Services]: 'services',
	[IconTypes.Deals]: 'tag',
};

export const transparentImage =
	'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
export const chatbotParentElId = 'chatbot-widget';

export const SESSION_COOKIE_NAME = 'ChatbotSession';
export const REFRESH_FLAG_COOKIE_NAME = 'ChatbotRefreshFlag';
export const TAB_INSTANCES_COOKIE_NAME = 'ChatbotTabInstances';
export const AUTH_TOKEN_COOKIE_NAME = 'ChatbotAuthToken';
export const CHAT_HISTORY_AUDIT_ACCESS_KEY_COOKIE_NAME =
	'chatbotChatHistoryAuditAccessKey';
export const BASKET_COOKIE_NAME = 'BasketSimple';
export const TAGGING_CLICK_EVENT_NAME = 'TrackClick';
export const VISIBILITY_CHANGE_EVENT_NAME = 'visibilitychange';

export const isTestMode = !!get('chatbotTestMode');
export const isQAMode = !!get('EnableChatbotQA');
export const chatbotEnvironmentOverride = get('ChatbotEnvironmentOverride');
export const chatbotClientVersionOverride = get('ChatbotClientVersionOverride');
export const shouldLogResponseMetaData = !!get('EnableChatbotResponseMetaData');
export const isReadOnlyMode = !!getUrlParamByKey('chatbotReadOnly');
export const isAuditMode = !!getUrlParamByKey('chatbotAudit');
export const isAutoScrollMode = getUrlParamByKey('chatbotDisableAutoScroll')
	? false
	: true;
export const sessionIdOverride = getUrlParamByKey('chatbotSessionId');

export const mvtConfig = getMvtConfig();

export const CONVERSATION_STARTER = mvtConfig.conversationStarter
	? mvtConfig.conversationStarter
	: 'HELP_AND_ADVICE';

export const LIVECHAT_CLOSING_QUESTION_INTENT = 'ASK_LIVECHAT_CLOSING_QUESTION';
export const LIVE_CHAT_INACTIVITY_INTENT = 'LC_INACTIVITY';

export const rootDomain = getRootDomain();
export const tabId = uuidv4();
export const originalDocumentTitle = document.title;

export const startLiveChatCspCheckMessage =
	'Before I connect you to a customer experience specialist I’d like to ask you a few questions about your query. Is your query about an existing order?';
